import functionsStyles from "./Functions.module.css";
import Icon from "../../components/Icon";
import React, { FunctionComponent, useEffect, useMemo } from "react";
import { rootPanel2Actions } from "../../reducers/rightPanel2.slice";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store/create-store";
import debounce from "lodash.debounce";
import { rootActions } from "../../reducers/root.slice";
import { selectWorkers } from "../../selectors/worker.selector";
import SectionTitle from "../../components/SectionTitle";
import { TWorkerState } from "../../reducers/worker.slice";
import classNames from "classnames";
import styles from "./Debug.module.css";

const WorkerState: FunctionComponent<{ state: TWorkerState }> = (props) => (
  <span
    className={classNames(styles.workerState, {
      [styles.busy]: props.state === "busy",
      [styles.idle]: props.state === "idle",
    })}
  />
);

const Debug = () => {
  const { rotation, workers } = useSelector(selectDebug);
  const dispatch = useDispatch();

  const rotationChange = (
    newRotation: Partial<{ x: number; y: number; z: number }>
  ) => {
    dispatch(
      rootPanel2Actions.setDebug({
        rotation: {
          ...rotation,
          ...newRotation,
        },
      })
    );
  };

  const debouncedGenerateGraph = useMemo(() => {
    // TODO this should not be called on mount
    return debounce(() => {
      dispatch(rootActions.generateGraph());
    }, 100);
  }, []);

  useEffect(debouncedGenerateGraph, [rotation]);

  return (
    <div className={functionsStyles.wrapper}>
      <ul>
        <li className={functionsStyles.listItem}>
          <label className={functionsStyles.field}>
            <Icon name="360" /> Rotation X
          </label>

          <span className={functionsStyles.inlineListItem}>
            <input
              className={functionsStyles.range}
              type="range"
              name="rotationX"
              min="0"
              max="360"
              step="1"
              value={String(rotation.x)}
              onChange={(event) =>
                rotationChange({
                  x: Number(event.target.value),
                })
              }
            />
            <input
              type="number"
              min={0}
              max={360}
              value={rotation.x}
              onChange={(event) =>
                rotationChange({
                  x: Number(event.target.value),
                })
              }
            />
          </span>
        </li>

        <li className={functionsStyles.listItem}>
          <label className={functionsStyles.field}>
            <Icon name="360" /> Rotation Y
          </label>

          <span className={functionsStyles.inlineListItem}>
            <input
              className={functionsStyles.range}
              type="range"
              name="rotationY"
              min="0"
              max="360"
              step="1"
              value={String(rotation.y)}
              onChange={(event) =>
                rotationChange({
                  y: Number(event.target.value),
                })
              }
            />
            <input
              type="number"
              min={0}
              max={360}
              value={rotation.y}
              onChange={(event) =>
                rotationChange({
                  y: Number(event.target.value),
                })
              }
            />
          </span>
        </li>

        <li className={functionsStyles.listItem}>
          <label className={functionsStyles.field}>
            <Icon name="360" /> Rotation Z
          </label>

          <span className={functionsStyles.inlineListItem}>
            <input
              className={functionsStyles.range}
              type="range"
              name="rotationZ"
              min="0"
              max="360"
              step="1"
              value={String(rotation.z)}
              onChange={(event) =>
                rotationChange({
                  z: Number(event.target.value),
                })
              }
            />
            <input
              type="number"
              min={0}
              max={360}
              value={rotation.z}
              onChange={(event) =>
                rotationChange({
                  z: Number(event.target.value),
                })
              }
            />
          </span>
        </li>
      </ul>

      <SectionTitle>Workers</SectionTitle>

      <ul className={styles.workerList}>
        {Object.keys(workers).map((workerName) => {
          const worker = workers[workerName as keyof typeof workers];
          return (
            <li key={workerName} className={styles.workerListItem}>
              <WorkerState state={worker.state} /> {workerName}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const selectDebug = (state: TRootState) => {
  return {
    rotation: state.rightPanel2.debug.rotation,
    workers: selectWorkers(state),
  };
};

export default Debug;
